import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper'

import './travels-slider.scss'

const selectors = {
  container: '[data-ts]',

  tab: '[data-ts-tab]',
  pane: '[data-ts-pane]',

  hidden: 'hidden',
  active: 'active',
}

const setActiveTab = (activeIndex, tab, tabs, panes, swiper) => {
  tabs?.forEach((tab, index) => tab.classList[activeIndex === index ? 'add' : 'remove'](selectors.active))
  panes?.forEach((pane) => {
    const isHidden = tab.dataset.tsTab !== pane.dataset.tsPane

    pane.classList[isHidden ? 'add' : 'remove'](selectors.hidden)
  })

  swiper.update()
}

const initTravelSlider = (container) => {
  const slides = container.querySelectorAll('.swiper-slide')
  const tabs = container.querySelectorAll(selectors.tab)
  const panes = container.querySelectorAll(selectors.pane)

  const swiper = new Swiper(container.querySelector('.swiper'), {
    modules: [Navigation, Scrollbar, Pagination],

    slidesPerView: 'auto',
    spaceBetween: 8,

    scrollbar: {
      el: container.querySelector('.swiper-scrollbar'),
      draggable: true,
    },

    navigation: {
      prevEl: container.querySelector('.prev'),
      nextEl: container.querySelector('.next'),
    },

    pagination: {
      el: container.querySelector('.swiper-pagination'),
    },

    breakpoints: {
      1024: {
        enabled: true,
        slidesPerView: slides.length <= 3 ? 3 : 4,
      },
    },
  })

  if (tabs?.length) {
    tabs?.forEach((tab, activeIndex) => {
      tab.addEventListener('click', () => setActiveTab(activeIndex, tab, tabs, panes, swiper))
    })

    setActiveTab(0, tabs[0], tabs, panes, swiper)
  }
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    const containers = document.querySelectorAll(selectors.container)

    containers?.forEach(initTravelSlider)
  },
  { once: true }
)
